import React, { Component } from 'react';
import {
  Alert,
  ActivityIndicator,
  ScrollView,
  View,
  Text,
} from 'react-native';

import EonnTitle from '../components/title';
import EonnButton from '../components/button';
import { mstyles } from '../constants/MainStyles';
import common from '../common';
import FirebaseUsers from '../firebase/firebase_users.js'

export default class Screen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      error: "",
      accountLink: null,
    };

    //global.user.email = "albius0@yahoo.com";

    this.createConnectedAccount()
    .then(() => this.createAccountLink())
    .catch((error) => {
      console.error('Error creating Stripe account:', error);
      this.setState({
        loading: false,
        error: 'Failed to create Stripe account',
      });
    });

  }

  async createConnectedAccount() {
    if (global.user.stripeId) {
      return true;
    }
    try {
      const firstName = global.user.firstName || global.user.fname || '';
      const lastName = global.user.lastName || global.user.lname || '';
      const email = global.user.email;
      const businessType = (global.user.businessType || 'individual');
      const phone = global.user.phone || '';
      const businessName = global.user.businessName || '';
      const website = global.user.techLink ? `https://consult.autoteletech.com/${decodeURIComponent(global.user.techLink)}` : 'https://www.autoteletech.com';
      const uid = global.user.uid || '';

      console.log('creating connected account for:', email);
      const response = await fetch('https://us-central1-eonn-teletech.cloudfunctions.net/createConnectedAccount', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email,
          firstName,
          lastName,
          businessType,
          phone,
          businessName,
          website,
          uid,
          testing: global.user.t_testing,
        }),
      });

      const result = await response.json();
      if (!response.ok) {
        throw new Error(result?.error || 'Failed to create connected account');
      }

      const { accountId } = result;
      global.user.stripeId = accountId;
      console.log('connected account created:', accountId);

      let profilePictureUrl = global.user.profilePicture;
      if (profilePictureUrl && !profilePictureUrl.startsWith('http')) {
        profilePictureUrl = await FirebaseUsers.uploadProfilePicture(profilePictureUrl);
        console.log('Image uploaded successfully:', profilePictureUrl);
        global.user.profilePicture = profilePictureUrl;
      }

      await FirebaseUsers.updateUserInfo();

      return true;

    } catch (error) {
      console.error('Error creating connected account:', error);
      this.setState({
        loading: false,
        error: 'Failed to create Stripe account',
      });
      throw error;
    }
  }

  async createAccountLink() {
    try {
      console.log("creating account link:");
      const response = await fetch('https://us-central1-eonn-teletech.cloudfunctions.net/createAccountLink', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          accountId: global.user.stripeId,
          successUrl: window.location.href.split('?')[0] + '?side=tech',
          failureUrl: 'https://eonn-teletech.web.app/StripeFailure.htm',
          testing: global.user.t_testing,
        }),
      });

      if (response.status !== 200) {
        // Handle the error case
        console.error('Error creating Stripe account link: Server returned status', response.status);
        this.setState({
          loading: false,
          error: 'Failed to create Stripe account link',
        });
      } else {
        const responseText = await response.text();
        console.log('Raw response text:', responseText);
        const { url } = JSON.parse(responseText);

        common.storeUserData()
        .then(() => {
          window.location.href = url;
        });
      }
      

    } catch (error) {
      console.error('Error creating Stripe account link:', error);
      this.setState({
        loading: false,
        error: 'Failed to create Stripe account link',
      });
    }
  }

  render() {
    const { loading, accountLink } = this.state;
    
    return (

      <View style={mstyles.container}>
        { loading ? 
          <ActivityIndicator size="large" style={{marginTop:20}}/>
        :
          <Text>There was an error creating your Stripe account</Text>
        }

      </View>

    );
  }
}
